import { BuildingLoaderPage } from "./BuildingLoaderPage";
import { BuildingSelectionLoader } from "./BuldingSelectionLoader";
import { MyChimneyContextProvider } from "./MyChimneyContext";
import { BuildingLoader } from "firefly-my-chimney-ts-building";
import React, { FC, ReactNode } from "react";
import { NoBuildingsPage } from "./NoBuildingsPage";
import { createLazyRoute, Outlet } from "@tanstack/react-router";

export interface MyChimneyContextLoaderProps {
  children: ReactNode;
}
export const MyChimneyContextLoader: FC<MyChimneyContextLoaderProps> = (
  props
) => {
  const refreshCache =
    localStorage.getItem("BuildingLoader.refreshCache") === "true";
  return (
    <BuildingLoader
      refreshCache={refreshCache}
      loader={<BuildingLoaderPage />}
      noBuildings={<NoBuildingsPage />}
    >
      {(buildings, onBuildingsChange) => {
        return (
          <BuildingSelectionLoader buildings={buildings}>
            {(selectedBuilding, selectedFlue) => (
              <MyChimneyContextProvider
                buildings={buildings}
                onBuildingsChange={onBuildingsChange}
                selectedBuilding={selectedBuilding}
                selectedFlue={selectedFlue}
              >
                {props.children}
              </MyChimneyContextProvider>
            )}
          </BuildingSelectionLoader>
        );
      }}
    </BuildingLoader>
  );
};

export const MyChimneyContextLoaderRoute = createLazyRoute(
  "/_myChimneyContext"
)({
  component: () => (
    <MyChimneyContextLoader>
      <Outlet />
    </MyChimneyContextLoader>
  ),
});
